module.exports = new __parcel__URL__("bladevortex.676185c8.png").toString();